import * as React from "react";
import {Address} from "../../models/Address";
import {Name} from "../../models/Name";

export interface ReadonlyAddressProps
{
	address: Address
}

export class ReadonlyAddress extends React.Component<ReadonlyAddressProps, any>
{
	render()
	{
		const address = this.props.address;
		return <address>

			       {this.renderName(address.person) }
			       {this.renderLine(address.nameOrCompany) }
			       {this.renderLine(address.phoneNumber) }
			       {this.renderLine(address.line1) }
			       {this.renderLine(address.line2) }
			       {this.renderLine(address.line3) }
			       {address.city}, {address.stateProvince} {address.postalCode}<br/>
			       {address.country}
		       </address>;
	}

	private renderName(name: Name)
	{
		if (name == null)
		{
			return null;
		}
		if ((name.last === null || name.last.length === 0) && (name.first === null || name.first.length === 0))
		{
			return null;
		}
		return <strong>
			       {name.first} {name.last}<br/>
		       </strong>;
	}

	private renderLine(addressData: string)
	{
		if (addressData == null || addressData.length === 0)
		{
			return null;
		}
		return <span>
			       {addressData}<br/>
		       </span>;
	}
}


// WEBPACK FOOTER //
// ./src/components/common/ReadonlyAddress.tsx